import { render, staticRenderFns } from "./addCourseRelative.vue?vue&type=template&id=7a650542&scoped=true&"
import script from "./addCourseRelative.vue?vue&type=script&lang=js&"
export * from "./addCourseRelative.vue?vue&type=script&lang=js&"
import style0 from "./addCourseRelative.vue?vue&type=style&index=0&id=7a650542&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a650542",
  null
  
)

export default component.exports